import styled from 'styled-components';
const LogItemInfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;
export default LogItemInfoContainer;
